import { DatePipe } from '@angular/common';
import { Component, OnInit, Type } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { APICallService } from 'src/app/services/api-call.service';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { LineLovDialogComponent } from '../../common/line-lov-dialog/line-lov-dialog.component';
import { PerilLovComponent } from '../../common/peril-lov/peril-lov.component';

interface RowData {
    mHighRisk: any
}

@Component({
    selector: 'motor-high-risk-maintenance',
    templateUrl: './motor-high-risk-maintenance.html',
    styleUrls: ['./motor-high-risk-maintenance.css']
})
export class MotorHighRiskMaintenanceComponent implements OnInit, LeaveConfirmation {

    moduleId: string = 'BMM060';
    moduleName: string = "";
    formHider: boolean = false;  

    constructor(
        private fb: FormBuilder,
        private _matDialog: MatDialog,
        private _api: APICallService,
        public _formService: FormService,
        private _jsonDS: JsonDataService,
        private _securityService: SecurityService,
        private _userDetailService: UserDetailsService,
        private _appMessageService: AppMessageService
    ) {
        this.userIdLoggedIn = this._userDetailService.userId || "";
    }

    ngOnInit(): void {
        this.moduleName = this._jsonDS.data.moduleList.filter((data: any) => { return data.moduleId === this.moduleId })[0].moduleDesc.toUpperCase();
        this.getData.mHighRisk();
    }

    canDeactivate(): boolean | Observable<boolean> {
        return this.tblConfig.mHighRisk.tblData.filter((d: any) => (d.temp === true || d.onDbButUpdatedTemp === true)).length > 0 ? false : true;
    }

    test() {
        //console.table(this.forms.mHighRiskForm.value);
    }

    allowNumericDigitsOnly(event: any) {
        try {
            if (/[0-9.]/.test(String.fromCharCode(event.keyCode))) {
                return true;
            } else {
                event.preventDefault();
                return false;
            }
        } catch (e) {
    console.error(e);
            return undefined;
        }
    }

    /* Boolean Stuffs */

    public btns = {
        mHighRisk: {
            updateDisabled: true,
            deleteDisabled: true,
            saveDisabled: true,
            addDisabled: false,
        }
    }

    public showForm = {
        mHighRisk: true
    }

    /* Data Stuffs */

    private rowData: RowData = {
        mHighRisk: null
    }

    private errorMessage: RowData = {
        mHighRisk: null
    }

    private userIdLoggedIn: string;

    /* Form Object  */

    public forms = {
        mHighRiskForm: this.fb.group({
            highRiskId: [''],
            highRiskIdPadded: [{ value: '', disabled: 'true' }],
            activeTag: ['A', [Validators.required]],
            highRiskDesc: ['', [this.checkDuplicateHighRiskDesc('mHighRisk'), Validators.maxLength(50), Validators.required]],
            remarks: ['', [Validators.maxLength(4000)]],
            lastUpdateUser: [{ value: '', disabled: 'true' }],
            lastUpdate: [{ value: '', disabled: 'true' }]
        }),
        resetMHighRiskForm: () => {
            this.forms.mHighRiskForm.reset();
            this.forms.mHighRiskForm.patchValue({
                activeTag: 'A'
            });
            this.btns.mHighRisk.updateDisabled = true;
            this.btns.mHighRisk.deleteDisabled = true;
            this._formService.hideFormMsg("mHighRisk-error-message");
            this.rowData.mHighRisk = null;
        }
    };

    /* Table Object */

    public tblConfig: RowData = {
        mHighRisk: {
            cols: [
                {
                    key: "HIGH_RISK_ID_PADDED",
                    header: "High Risk ID",
                    dataType: "string",
                    width: '24%'
                },
                {
                    key: "HIGH_RISK_DESC",
                    header: "HIGH RISK",
                    dataType: "string",
                    width: '70%'
                },
                {
                    key: "ACTIVE_TAG",
                    header: "A",
                    dataType: "checkbox",
                    width: '6%'
                },
            ],
            tblData: [],
            selection: "single",
            paginator: true,
            rowsPerPage: 10,
            lazy: false,
            totalRecords: 15,
            loading: false,
        }
    }

    private formManipulation = {
        mHighRisk: {
            dbToForm: function (data: any) {
                return {
                    highRiskId: (data.HIGH_RISK_ID) ? data.HIGH_RISK_ID : null,
                    highRiskIdPadded: data.HIGH_RISK_ID_PADDED,
                    activeTag: data.ACTIVE_TAG,
                    highRiskDesc: data.HIGH_RISK_DESC,
                    remarks: data.REMARKS,
                    lastUpdateUser: data.USER_ID,
                    lastUpdate: data.LAST_UPDATE
                };
            },
            formToDb: function (data: any) {
                return {
                    HIGH_RISK_ID: data.highRiskId,
                    HIGH_RISK_ID_PADDED: (data.highRiskId) ? data.highRiskId.toString().padStart(2, 0) : null,
                    ACTIVE_TAG: data.activeTag,
                    HIGH_RISK_DESC: data.highRiskDesc,
                    REMARKS: data.remarks,
                    USER_ID: null,
                    LAST_UPDATE: null
                };
            }
        }
    }

    public selections = {
        activeTypes: [
            { cd: 'A', name: 'Yes' },
            { cd: 'I', name: 'No' },
        ]
    };

    private getData = {
        mHighRisk: () => {
            try {
                this.tblConfig.mHighRisk.tblData = [];
                this.tblConfig.mHighRisk.loading = true;
                this._jsonDS.contorlLoading(true);
                this._api.getMHighRisk({
                    moduleId: this.moduleId,
                    userId: this._userDetailService.userId,
                    type: "MODULE"
                }).subscribe({ 
                    next: (response: any) => {
                        this._securityService.checkRequestKeyResponse(response, () => {
                            this._securityService.hasValidCsrfToken(response, () => {
                                try {
                                    if (response.status === 'SUCCESS') {
                                        response = JSON.parse(this._jsonDS.decrypt(response.response));
                                        this._jsonDS.contorlLoading(false);
                                        let filteredData = response.data;
                                        this.tblConfig.mHighRisk.tblData = filteredData;
                                    } else {
                                        this.tblConfig.mHighRisk.loading = false;
                                        this._jsonDS.contorlLoading(false);
                                        this._appMessageService.showAppMessage(response.message, "error");
                                    }
                                } catch (e) {
    console.error(e);
                                }
                                this.tblConfig.mHighRisk.loading = false;
                            });
                        });
                    }, error: (e: any) => {
                        this.tblConfig.mHighRisk.loading = false;
                        this._jsonDS.contorlLoading(false);
                    }
                });
            } catch (e) {
    console.error(e);
                this.tblConfig.mHighRisk.loading = false;
                this._jsonDS.contorlLoading(false);
            }
        }
    }

    public onRowClick = {
        mHighRisk: (ev: any) => {
            try {
                ev.update = true;
                this.rowData.mHighRisk = ev;
                this.populateFormFromTable.mHighRisk();
            } catch (e) {
    console.error(e);
                this.forms.resetMHighRiskForm();
                this.rowData.mHighRisk = null;
            }
        }
    }

    private populateFormFromTable = {
        mHighRisk: () => {
            try {
                let data = this.rowData.mHighRisk;
                this.btns.mHighRisk.updateDisabled = !data.update;
                this.btns.mHighRisk.deleteDisabled = !data.temp;
                this.forms.mHighRiskForm.patchValue(this.formManipulation.mHighRisk.dbToForm(data));
            } catch (e) {
    console.error(e);
            }
        }
    }

    public onAdd = {
        mHighRisk: () => {
            try {
                this._formService.hideFormMsg("mHighRisk-error-message");
                if (this.forms.mHighRiskForm.valid && !this.checkRequired()) {
                    let rowToBeAdded: { [key: string]: any } = this.formManipulation.mHighRisk.formToDb(this.forms.mHighRiskForm.value);
                    rowToBeAdded.temp = true;
                    this.tblConfig.mHighRisk.tblData = [rowToBeAdded, ...this.tblConfig.mHighRisk.tblData];
                    this.forms.resetMHighRiskForm();
                    this.btns.mHighRisk.saveDisabled = false;
                } else {
                    this.showErrorValidator.mHighRisk();
                }
            } catch (e) {
    console.error(e);
            }
        }
    }

    public onDelete = {
        mHighRisk: () => {
            try {
                this.tblConfig.mHighRisk.tblData = this.tblConfig.mHighRisk.tblData.filter((d: any) => {
                    return d !== this.rowData.mHighRisk;
                });
                this.forms.resetMHighRiskForm();
                let toBeSaved = this.tblConfig.mHighRisk.tblData.filter((d: any) => (d.temp === true || d.onDbButUpdatedTemp === true));
                if (toBeSaved.length === 0) {
                    this.btns.mHighRisk.saveDisabled = true;
                } else {
                    this.btns.mHighRisk.saveDisabled = false;
                }
            } catch (e) {
    console.error(e);
            }
        }
    }

    public onUpdate = {
        mHighRisk: () => {
            try {
                this._formService.hideFormMsg("mHighRisk-error-message");
                if (this.forms.mHighRiskForm.valid && !this.checkRequired()) {
                    let toBeUpdatedIndex = this.tblConfig.mHighRisk.tblData.indexOf(this.rowData.mHighRisk);
                    let rowToBeUpdated: { [key: string]: any } = this.formManipulation.mHighRisk.formToDb(this.forms.mHighRiskForm.value);
                    if (this.rowData.mHighRisk.temp) {
                        rowToBeUpdated.temp = true;
                    } else {
                        rowToBeUpdated.onDbButUpdatedTemp = true;
                    }
                    this.forms.resetMHighRiskForm();
                    this.tblConfig.mHighRisk.tblData[toBeUpdatedIndex] = rowToBeUpdated;
                    this.btns.mHighRisk.saveDisabled = false;
                    this.tblConfig.mHighRisk.tblData = [... this.tblConfig.mHighRisk.tblData];
                } else {
                    this.showErrorValidator.mHighRisk();
                }
            } catch (e) {
    console.error(e);
            }
        }
    }

    public onSave = {
        mHighRisk: () => {
            this.showForm.mHighRisk = false;
            this._formService.showFormLoader(null, "mHighRisk-maintenance-loading", "Saving.<br>Please wait ...", null, null);
            let toBeSaved = this.tblConfig.mHighRisk.tblData.filter((d: any) => (d.temp === true || d.onDbButUpdatedTemp === true));
            if (toBeSaved.length > 0) {
                toBeSaved.map((d: any) => {
                    d.LAST_USER = this.userIdLoggedIn;
                });
                this._api.saveMHighRisk(toBeSaved).subscribe({
                    next: (response: any) => {
                        this._securityService.checkRequestKeyResponse(response, () => {
                            this._securityService.hasValidCsrfToken(response, () => {
                                if (response.status === 'SUCCESS') {
                                    this.onComplete.mHighRisk();
                                } else {
                                    this.onComplete.mHighRiskError();
                                }
                            });
                        });
                    }, error: (response: any) => {
                        this.onComplete.mHighRiskError();
                    },
                });
            } else {
                this.onComplete.mHighRisk();
            }
        }
    }

    openDialog(title: string, contentTitle: string, contentDetail: string) {
        try {
            this._matDialog.open(DialogMsgComponent, {
                disableClose: true,
                width: '512px',
                data: {
                title: title,
                content:
                    title === 'SUCCESS'
                    ? `${contentTitle} details successfully ${contentDetail}!`
                    : `${contentTitle} details ${contentDetail} failed!`,
                },
            });
        } catch (e) {
    console.error(e);
        }
    }

    private onComplete = {
        mHighRisk: () => {
            this.getData.mHighRisk();
            this.btns.mHighRisk.saveDisabled = true;
            this.showForm.mHighRisk = true;
            this._formService.hideFormLoader("mHighRisk-maintenance-loading");
            this.openDialog('SUCCESS', 'Motor High Risk', 'saved');
        },
        mHighRiskError: () => {
            this.showForm.mHighRisk = true;
            this.btns.mHighRisk.saveDisabled = false;
            this.openDialog('FAILED', 'Motor High Risk', 'saving');
            this._formService.hideFormLoader("mHighRisk-maintenance-loading");
        }
    }

    /* Validator Stuffs Down here */

    checkDuplicateHighRiskDesc(module: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value === null ? control.value : control.value.trim();
            if (!value) {
                return null;
            }
            let hasDuplicate: boolean = this.tblConfig[module as keyof RowData].tblData.filter((d: any) => {
                if (!this.rowData[module as keyof RowData]) {
                    return d.HIGH_RISK_DESC.toUpperCase() === value.toUpperCase();
                } else {
                    return this.rowData[module as keyof RowData].HIGH_RISK_DESC.toUpperCase() !== value.toUpperCase() && d.HIGH_RISK_DESC.toUpperCase() === value.toUpperCase();
                }
            }).length > 0 ? true : false;
            return hasDuplicate ? { hasDupeHighRiskDesc: true } : null;
        }
    }

    /*checkDuplicatePaytDesc(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (!value) {
                return null;
            } 
            let hasDuplicate: boolean = this.tblConfig.srcFunds.tblData.filter((d: any) => {
                if (!this.rowData.srcFunds) {
                    return d.PAYT_DESC === value;
                } else {
                    return this.rowData.srcFunds.PAYT_DESC !== value && d.PAYT_DESC === value;
                }
            }).length > 0 ? true : false;
            return hasDuplicate ? { hasDupePaytDesc: true } : null;
        }
    }

    checkDuplicateSeqNo(module: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (!value) {
                return null;
            }
            let hasDuplicate: boolean = this.tblConfig[module as keyof RowData].tblData.filter((d: any) => {
                if (!this.rowData[module as keyof RowData]) {
                    return d.SEQ_NO == value;
                } else {
                    return this.rowData[module as keyof RowData].SEQ_NO != value && d.SEQ_NO == value;
                }
            }).length > 0 ? true : false;
            return hasDuplicate ? { hasDupeSeqNo: true } : null;
        }
    }*/
    checkRequired(){
        if(this.forms.mHighRiskForm.get('highRiskDesc')?.value.trim()=='' || this.forms.mHighRiskForm.get('highRiskDesc')?.value==null) {
          return true;
        }else{
          return false;
        }
      }
    public showErrorValidator = {
        mHighRisk: () => {
            try {
                Object.keys(this.forms.mHighRiskForm.controls).forEach(key => {
                    const controlErrors = this.forms.mHighRiskForm.get(key)?.errors;
                    if (controlErrors != null) {
                        Object.keys(controlErrors).forEach(keyError => {
                            if (keyError == 'required' && controlErrors[keyError] === true){
                                this.errorMessage.mHighRisk = "There are missing information. Please provide necessary information needed.";
                            } else if (keyError == 'hasDupeHighRiskDesc' && controlErrors[keyError] === true) {
                                this.errorMessage.mHighRisk = "Motor High Risk already exists. Please add a unique Motor High Risk.";
                            }
                        });
                    }
                });
                if(this.checkRequired()){
                    this.errorMessage.mHighRisk = "There are missing information. Please provide necessary information needed.";
                }
                this._formService.showFormMsg("mHighRisk-error-message", this.errorMessage.mHighRisk, "E");
            } catch (e) {
    console.error(e);
            }
        }
    }
}
